import type React from "react";

import type { IApolloIntroductionBlocks } from "@/api/interfaces/apolloIntroductionLayout";
import IntroductionBlock from "@/base/blocks/IntroductionBlocks/IntroductionBlock";
import { H5 } from "@/base/components/Global";
import { Col, Row } from "@/base/components/Layout";
import { APOLLO_STAR_ICON_ORANGE_BORDER } from "@/constants/blobIcons";

export const INTRO_BLOCK_ID = "apollo-club-introduction-container";

type IntroductionContents = {
  block?: IApolloIntroductionBlocks;
};

const IntroductionBlocks: React.FC<IntroductionContents> = ({ block }) =>
  block ? (
    <>
      {block?.title && (
        <Row id={INTRO_BLOCK_ID}>
          <Col col={12}>
            <H5 prefixIcon={APOLLO_STAR_ICON_ORANGE_BORDER}>{block.title}</H5>
          </Col>
        </Row>
      )}
      {block?.introductionBlocks?.map((club, idx) => (
        <IntroductionBlock idx={idx} key={club.infoTitle} {...club} />
      ))}
    </>
  ) : null;

export default IntroductionBlocks;
